module.exports = __webpack_public_path__ + "static/media/warning_deactivate_red.5193ce1c.svg";